/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module CoreModule
 */

import {
    Pipe,
    PipeTransform,
} from '@angular/core';

import { AlertLevel } from 'generated-types';

/**
 * @description Pipe for returning color based on Alert Level.
 * @author Shahab Hashmi
 */
@Pipe({
    name: 'alertLevelColor',
})
export class AlertLevelColorPipe implements PipeTransform {
    // eslint-disable-next-line class-methods-use-this
    public transform(level: AlertLevel): string {
        switch (level) {
            case AlertLevel.ALERT_HIGH:
                return 'danger';

            case AlertLevel.ALERT_LOW:
                return 'warning';

            case AlertLevel.ALERT_MEDIUM:
                return 'primary';

            default:
                return '';
        }
    }
}
